var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiSelectDuplicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160530",
    "data-name": "Group 160530",
    transform: "translate(-616 -160)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1920",
    "data-name": "Rectangle 1920",
    width: 16,
    height: 16,
    transform: "translate(616 160)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "copy-outline",
    transform: "translate(572 116)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1921",
    "data-name": "Rectangle 1921",
    width: 6,
    height: 6,
    rx: 1,
    transform: "translate(50 50)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M54.315,49.506l.009-.452A1.057,1.057,0,0,0,53.271,48H49.2A1.208,1.208,0,0,0,48,49.2v4.066a1.057,1.057,0,0,0,1.054,1.054h.452",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#0032c5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiSelectDuplicateIcon);
export default __webpack_public_path__ + "static/media/MultiSelectDuplicate-icon.75224b16da19a862659a8872e2eaaf59.svg";
export { ForwardRef as ReactComponent };